import {createStore, applyMiddleware} from 'redux';
import logger from 'redux-logger';
import {persistStore} from 'redux-persist';
import rootReducer from './root-reducer';
import createSagaMiddleWare from 'redux-saga';
import rootSaga from './root-saga';

const sagaMiddleware = createSagaMiddleWare();

const middlewares = [sagaMiddleware];

if(process.env.NODE_ENV === 'development'){
    middlewares.push(logger);
}

export const store = createStore(rootReducer, applyMiddleware(...middlewares)); //implementing persist-reduxxee

sagaMiddleware.run(rootSaga)

export const persistor = persistStore(store);

